export default __webpack_public_path__ + "static/media/burn.cdc2c075.png";